import { render, staticRenderFns } from "./AuditPendenciesExport.vue?vue&type=template&id=84d521d2"
import script from "./AuditPendenciesExport.vue?vue&type=script&lang=js"
export * from "./AuditPendenciesExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports